import React from "react";
import { reviews, PURCHASE_URL } from "../mock";
import { Star, BadgeCheck, ShoppingCart } from "lucide-react";

const Testimonials = () => {
  return (
    <section className="relative py-20 px-4">
      <div className="mx-auto max-w-6xl">
        <div className="text-center">
          <p className="text-xs font-semibold tracking-[0.3em] text-sky-400 uppercase">
            Client Reviews
          </p>
          <h2 className="mt-3 text-3xl sm:text-4xl md:text-5xl font-extrabold text-white">
            Success Stories From Our Clients
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-slate-400">
            Find out how our clients are benefiting from our trading solutions
            and achieving their financial goals.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {reviews.map((r) => (
            <div
              key={r.id}
              className="group rounded-2xl border border-slate-700/60 bg-slate-900/40 p-6 backdrop-blur transition-all duration-300 hover:border-sky-400/60 hover:shadow-[0_0_30px_rgba(59,130,246,0.2)]"
            >
              <div className="flex items-center gap-1 text-amber-400">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <div className="mt-4 overflow-hidden rounded-xl bg-slate-950/50">
                <img
                  src={r.image}
                  alt={r.name}
                  className="w-full h-[320px] object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="mt-4">
                <p className="font-bold text-white">{r.name}</p>
                <div className="mt-1 inline-flex items-center gap-1.5 text-sm text-emerald-400">
                  <BadgeCheck className="h-4 w-4" />
                  {r.purchase}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href={PURCHASE_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 rounded-full bg-gradient-to-r from-sky-500 to-blue-600 px-8 py-3.5 font-bold text-white tracking-wider text-sm shadow-[0_0_40px_rgba(59,130,246,0.4)] transition-transform duration-300 hover:scale-[1.03] hover:shadow-[0_0_60px_rgba(59,130,246,0.65)]"
          >
            <ShoppingCart className="h-4 w-4" />
            GET SWIFT-AI INDICATOR
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
